import {
  CommonServices,
  ConfirmModal,
  SharedValidators,
} from 'src/modules/shared';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ContactProvider } from '../../services';
import { AppFilter } from 'src/modules/shared/models/filter';
import { takeUntil, map } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent {
  @ViewChild('input') input: ElementRef;
  public company_type: any[];
  private unsubscribe$: Subject<void> = new Subject<void>();
  showRenderer: boolean;

  public detailForm: FormGroup;
  public formSubmitAttempt: boolean = false;
  public createLoading: boolean = false;
  public createSuccess: boolean = false;
  public createError: string = null;
  public complaintTypes: any[];
  public msg;
  contactDetails: any;
  loadingScroll: boolean;
  contactMessage: any;
  structure: any[];
  contactStructure: any;
  commentError: string;
  messageOn: boolean = false;
  success;
  pending;
  //loading icon on clicking register.

  optionParams: AppFilter;
  filterType: AppFilter;
  loading: boolean;
  loadingTopics: boolean = true;
  loadingSubtopics: boolean = true;

  message = '';
  collapse = false;
  topics!: any[];
  subtopics!: any[];

  companyType = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'actual_company_type',
      },
    ],
  };

  error: string | null;

  constructor(
    private _contactsvc: ContactProvider,
    private fb: FormBuilder,
    private commonServices: CommonServices,
    private router: Router,
    private modalService: SuiModalService
  ) {
    this.getTopics();
    // initialize  option filter
    this.optionParams = new AppFilter({ sidx: 'complaintTypeId', rows: 5 });
    // initialize option type filer
    this.filterType = new AppFilter({ sidx: 'complaintTypeId' });

    this.commonServices
      .getTemplate({ messageTemplateId: 'FEEDBACK_NOTE' })
      .subscribe((res: any) => {
        this.contactMessage = res.mailTemplate;
      });

    this.commonServices
      .getTemplate({ messageTemplateId: 'CONTACT_SIDE_BAR' })
      .subscribe((res: any) => {
        this.contactDetails = res.mailTemplate;
      });

    this.detailForm = this.fb.group({
      topicId: ['', [Validators.required]],
      subtopicId: ['', [Validators.required]],
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required]],
      captcha: ['', [Validators.required]],
    });
  }
  send() {
    this.loading = true;
    this.formSubmitAttempt = false;
    if (this.detailForm.valid) {
      this._contactsvc
        .sendContactMessage({
          body: {
            // topicId: this.detailForm.value.topicId,
            subtopicId: this.detailForm.value.subtopicId,
            name: this.detailForm.value.name,
            email: this.detailForm.value.email,
            phone: this.detailForm.value.phone,
            subject: this.detailForm.value.subject,
            message: this.detailForm.value.message,
            captcha: this.detailForm.value.captcha,
          },
        })
        .subscribe(
          (d) => {
            this.loading = false;
            //   this.msg = 'success';
            this.detailForm.reset();
            this.input.nativeElement.focus();
            // this.success = 'Successful!';

            this.modalService
              .open(
                new ConfirmModal(
                  'Message Received',
                  'Thank you for your message! An email has been sent to you. Please click the link in the email to start a conversation with NCC. If you don’t see the email in your inbox, check your spam or junk folder. Thank you.',
                  ModalSize.Small,
                  'Okay',
                  ''
                )
              )
              .onApprove((payload) => {
                // this.getPage(1);
                // this.addWorkflowGroup(payload);
              })
              .onDeny(() => {});
          },
          (error) => {
            this.loading = false;
            //   this.msg = 'error';
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error;
          }
        );
    } else {
      this.formSubmitAttempt = true;
    }
  }

  getTopics() {
    this.loadingTopics = true;
    this._contactsvc.getTopics({ params: {} }).subscribe(
      (data: any[]) => {
        this.topics = data;
        // this.loadingTopics = false;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error;
      }
    );
  }

  getSubtopics(topicId) {
    this.detailForm.controls['subtopicId'].setValue('');
    this.loadingSubtopics = true;
    this._contactsvc.getSubtopics({ topicId }).subscribe(
      (data: any[]) => {
        this.subtopics = data;
        this.loadingSubtopics = false;
      },
      (error) => {
        this.error = error.error.errorMessage ?? error;
      }
    );
  }

  isFieldValid(field: string) {
    return (
      (!this.detailForm.get(field).valid &&
        this.detailForm.get(field).touched) ||
      (this.detailForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  displayFormCss(field: string) {
    return {
      loading: field,
    };
  }

  ngOnInit() {}
}
